<app-admin-sidebar></app-admin-sidebar>
<app-adminheader></app-adminheader>
<div class="dash">
  <div class="trip-acoordion">
    <div class="dash-trucks-top1">
      <a
        [ngClass]="{ active: tripType == 's9' }"
        (click)="select('s9')"
        >S9</a
      >
      <a
        [ngClass]="{ active: tripType == 'customer' }"
        (click)="select('customer')"
        >Customer</a
      >
      <a
        [ngClass]="{ active: tripType == 'driver' }"
        (click)="select('driver')"
        >Driver</a
      >
      <a
        [ngClass]="{ active: tripType == 'customerGST' }"
        (click)="select('customerGST')"
        >customerGST
      </a>
    </div>
    <div class="dash-trucks-top2">
      <button
        *ngIf="addBtn"
        type="button"
        class="button buttonBlue fixed-btn"
        (click)="addTax(selectedType)"
      >
        <img class="trucks-head-img" src="../../../assets/img/plus-white.svg" />
        Add
      </button>
      <button
        type="button"
        class="button delete-btn fixed-btn m-rl"
        *ngIf="taxSelect"
        (click)="selectTax(selectedType)"
      >
        <img
          class="trucks-head-img"
          src="../../../assets/img/check-circle.svg"
        />
        Select
      </button>
      <button
        type="button"
        class="button delete-btn fixed-btn m-rl"
        *ngIf="taxCancel"
        (click)="cancelTax()"
      >
        Cancel
      </button>
      <button
        type="button"
        class="button delete-btn fixed-btn m-rl"
        *ngIf="taxDelete"
        (click)="deleteTax()"
      >
        <img class="trucks-head-img" src="../../../assets/img/delete.svg" />
        Delete
      </button>
      <button
        type="button"
        *ngIf="searchButton"
        class="button search-btn fixed-btn"
        (click)="openSearch()"
      >
        <img src="../../../assets/img/search-white.svg" />
      </button>
      <div *ngIf="toggleSearch" class="search_toggle">
        <input
          uppercase
          class="search pl-2"
          placeholder="Search GST"
          id="searchTaxType"
          #newItem
          (input)="onInputChange(newItem.value)"
          (keyup.enter)="isInputValid && search(newItem.value)"
        />
        <button
          [disabled]="!isInputValid"
          class="search_number"
          *ngIf="search_Btn1"
          (click)="search(newItem.value)"
        >
          <img src="../../../assets/img/search-white.svg" />
        </button>
        <button
          *ngIf="clear_Btn"
          class="search_number1"
          (click)="resetSearch()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 16 16"
            fill="currentColor"
          >
            <path
              d="M5.28 4.22a.75.75 0 0 0-1.06 1.06L6.94 8l-2.72 2.72a.75.75 0 1 0 1.06 1.06L8 9.06l2.72 2.72a.75.75 0 1 0 1.06-1.06L9.06 8l2.72-2.72a.75.75 0 0 0-1.06-1.06L8 6.94 5.28 4.22Z"
            />
          </svg>
        </button>
      </div>
    </div>

    <div class="trucks">
      <div class="row" *ngIf="s9">
        <div [class.spinner]="s9loading"></div>

        <div class="row to_container" *ngIf="!s9Array?.length && !s9loading">
          <h4 class="error_msg">No Records Found.</h4>
        </div>
        <p class="consign" *ngIf="!s9Array">S9</p>
        <div class="col-md-3" *ngFor="let item of s9Array; let i = index">
          <div class="truckscol">
            <p class="heading-tax">
              <span>
                <mat-checkbox
                  *ngIf="checkBox"
                  [checked]="taxDeleteId.includes(item._id)"
                  (change)="matItem($event, item._id)"
                ></mat-checkbox>
              </span>
              <span>{{ item.tax_name }}</span>
              <span>
                <img
                  src="../../../assets/img/edit icon.png"
                  (click)="taxEdit(item)"
                  class="editimg"
                />
              </span>
            </p>
            <p class="truck-number">
              <span class="pull-left">Type:</span>
              <span class="pull-right">{{ item.tax_type }}</span>
            </p>
            <p class="truck-date">
              <span class="pull-left">Deduction:</span>
              <span class="pull-right">{{ item.tax_deduction }}</span>
            </p>
            <p class="truck-insu">
              <span class="pull-left">Comments:</span>
              <span class="pull-right">{{ item.tax_description }}</span>
            </p>
          </div>
        </div>
        <div *ngIf="last_page && last_page > 1" class="pagination">
          <button class="btn" [disabled]="fetch_page == 1" (click)="pagination('-1')">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="btn--icon"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M15 19l-7-7 7-7"
              />
            </svg>
          </button>
          <button class="btn" [disabled]="fetch_page == 1" (click)="pagination('first')">
            <img
              src="../../../assets/img/pagination-left.svg"
              alt=""
              class="btn--icon"
            />
          </button>
          <div class="pages">
            <a class="page" *ngIf="fetch_page > 0">{{ fetch_page }}</a>
          </div>
          <button class="btn" [disabled]="last_page == fetch_page" (click)="pagination('last')">
            <img
              src="../../../assets/img/pagination-right.svg"
              alt=""
              class="btn--icon"
            />
          </button>
          <button class="btn" [disabled]="last_page == fetch_page" (click)="pagination('1')">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="btn--icon"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M9 5l7 7-7 7"
              />
            </svg>
          </button>
        </div>
      </div>

      <div class="row" *ngIf="customer">
        <div [class.spinner]="customerloading"></div>
        <div
          class="row to_container"
          *ngIf="!customerArray?.length && !customerloading"
        >
          <h4 class="error_msg">No Records Found.</h4>
        </div>
        <p class="consign" *ngIf="!customerArray">Customer</p>
        <div class="col-md-3" *ngFor="let item of customerArray; let i = index">
          <div class="truckscol">
            <p class="heading-tax">
              <span>
                <mat-checkbox
                  *ngIf="customerCheckBox"
                  [checked]="taxDeleteId.includes(item._id)"
                  (change)="matItem($event, item._id)"
                ></mat-checkbox>
              </span>
              <span>{{ item.tax_name }}</span>
              <span>
                <img
                  src="../../../assets/img/edit icon.png"
                  class="editimg"
                  (click)="taxEdit(item)"
                />
              </span>
            </p>
            <p class="truck-number">
              <span class="pull-left">Type:</span>
              <span class="pull-right"> {{ item.tax_type }}</span>
            </p>
            <p class="truck-date">
              <span class="pull-left">Deduction:</span>
              <span class="pull-right"> {{ item.tax_deduction }}</span>
            </p>
            <p class="truck-insu">
              <span class="pull-left">Comments:</span>
              <span class="pull-right">{{ item.tax_description }} </span>
            </p>
          </div>
        </div>
        <div *ngIf="last_page && last_page > 1" class="pagination">
          <button class="btn" [disabled]="fetch_page == 1" (click)="pagination('-1')">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="btn--icon"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M15 19l-7-7 7-7"
              />
            </svg>
          </button>
          <button class="btn" [disabled]="fetch_page == 1" (click)="pagination('first')">
            <img
              src="../../../assets/img/pagination-left.svg"
              alt=""
              class="btn--icon"
            />
          </button>
          <div class="pages">
            <a class="page" *ngIf="fetch_page > 0">{{ fetch_page }}</a>
          </div>
          <button class="btn" [disabled]="last_page == fetch_page" (click)="pagination('last')">
            <img
              src="../../../assets/img/pagination-right.svg"
              alt=""
              class="btn--icon"
            />
          </button>
          <button class="btn" [disabled]="last_page == fetch_page" (click)="pagination('1')">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="btn--icon"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M9 5l7 7-7 7"
              />
            </svg>
          </button>
        </div>
      </div>

      <div class="row" *ngIf="driver">
        <div [class.spinner]="driverloading"></div>

        <div
          class="row to_container"
          *ngIf="!driverArray?.length && !driverloading"
        >
          <h4 class="error_msg">No Records Found.</h4>
        </div>
        <p class="consign" *ngIf="!driverArray">Driver</p>
        <div class="col-md-3" *ngFor="let item of driverArray; let i = index">
          <div class="truckscol">
            <p class="heading-tax">
              <span>
                <mat-checkbox
                  *ngIf="driverCheckBox"
                  [checked]="taxDeleteId.includes(item._id)"
                  (change)="matItem($event, item._id)"
                ></mat-checkbox>
              </span>
              <span>{{ item.tax_name }}</span>
              <span>
                <img
                  src="../../../assets/img/edit icon.png"
                  (click)="taxEdit(item)"
                  class="editimg"
                />
              </span>
            </p>
            <p class="truck-number">
              <span class="pull-left">Type:</span>
              <span class="pull-right"> {{ item.tax_type }}</span>
            </p>
            <p class="truck-date">
              <span class="pull-left">Deduction:</span>
              <span class="pull-right">{{ item.tax_deduction }} </span>
            </p>
            <p class="truck-insu">
              <span class="pull-left">Comments:</span>
              <span class="pull-right">{{ item.tax_description }} </span>
            </p>
          </div>
        </div>
        <div *ngIf="last_page && last_page > 1" class="pagination">
          <button class="btn" [disabled]="fetch_page == 1" (click)="pagination('-1')">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="btn--icon"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M15 19l-7-7 7-7"
              />
            </svg>
          </button>
          <button class="btn" [disabled]="fetch_page == 1" (click)="pagination('first')">
            <img
              src="../../../assets/img/pagination-left.svg"
              alt=""
              class="btn--icon"
            />
          </button>
          <div class="pages">
            <a class="page" *ngIf="fetch_page > 0">{{ fetch_page }}</a>
          </div>
          <button class="btn" [disabled]="last_page == fetch_page" (click)="pagination('last')">
            <img
              src="../../../assets/img/pagination-right.svg"
              alt=""
              class="btn--icon"
            />
          </button>
          <button class="btn" [disabled]="last_page == fetch_page" (click)="pagination('1')">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="btn--icon"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M9 5l7 7-7 7"
              />
            </svg>
          </button>
        </div>
      </div>

      <div class="row" *ngIf="customerGST">
        <div [class.spinner]="exmptedloading"></div>

        <div
          class="row to_container"
          *ngIf="!customerGSTArray?.length && !exmptedloading"
        >
          <h4 class="error_msg">No Records Found.</h4>
        </div>
        <p class="consign" *ngIf="!customerGSTArray">customerGST</p>
        <div class="col-md-3" *ngFor="let item of customerGSTArray; let i = index">
          <div class="truckscol">
            <p class="heading-tax">
              <span>
                <mat-checkbox
                  *ngIf="exemptCheckBox"
                  [checked]="taxDeleteId.includes(item._id)"
                  (change)="matItem($event, item._id)"
                ></mat-checkbox>
              </span>
              <span>{{ item.tax_name }}:{{ item.hsn_code }}</span>
              <span>
                <img
                  src="../../../assets/img/edit icon.png"
                  (click)="taxEdit(item)"
                  class="editimg"
                />
              </span>
            </p>
            <!-- <p class="truck-number">
              <span class="pull-left">Name:</span>
              <span class="pull-right">{{ item.tax_name }}</span>
            </p> -->
            <p class="truck-number">
              <span class="pull-left"><b>FCM:</b></span>
              <span class="pull-right">{{ item.fcm_deduction }}%</span>
            </p>
            <p class="truck-number">
              <span class="pull-left"><b>RCM:</b></span>
              <span class="pull-right">{{ item.rcm_deduction }}%</span>
            </p>
            <p class="truck-insu text-ellipsis-2" [title]="item.products?.join(', ')">
              <b>Products:</b> {{ item.products?.join(', ') || 'N/A' }}
            </p>
            <p class="truck-insu text-ellipsis-2" [title]="item.tax_description">
              <b>Comments:</b> {{ item.tax_description }}
            </p>
          </div>
        </div>
        <div *ngIf="last_page && last_page > 1" class="pagination">
          <button
            class="btn"
            [disabled]="fetch_page == 1"
            (click)="pagination('-1')"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="btn--icon"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M15 19l-7-7 7-7"
              />
            </svg>
          </button>
          <button class="btn" [disabled]="fetch_page == 1" (click)="pagination('first')">
            <img
              src="../../../assets/img/pagination-left.svg"
              alt=""
              class="btn--icon"
            />
          </button>
          <div class="pages">
            <a class="page" *ngIf="fetch_page > 0">{{ fetch_page }}</a>
          </div>
          <button class="btn" [disabled]="last_page == fetch_page" (click)="pagination('last')">
            <img
              src="../../../assets/img/pagination-right.svg"
              alt=""
              class="btn--icon"
            />
          </button>
          <button
            class="btn"
            [disabled]="last_page == fetch_page"
            (click)="pagination('1')"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="btn--icon"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M9 5l7 7-7 7"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
